import React, { useEffect, useState } from 'react'
import styles from './OauthCard.module.scss'
import { OauthCardType, clientCard } from './OauthCard.types'
import { connect } from 'react-redux'
import { fetchAllOauthClients } from '../../../tenants/create-account-signing-client/AccountSigningClient.actions'
import { Translate } from 'react-localize-redux'
import { deleteOauthClient, enableDisableOauthClient, regenerateOauthClientSecret } from '../../Settings.actions'
import { translate } from '../../../../shared/helpers/utils'
import {
  Card,
  CardContainer,
  CardContent,
  CardHeader,
  CardSizeTypes,
  CopyModal,
  CopyModalStepType,
  Tag,
  TagType
} from '@digicert/dcone-common-ui'

const OauthCard = (props: OauthCardType) => {
  const [clients, setClients] = useState<clientCard[]>()
  const [generateModalVisible, setGenerateModalVisible] = useState(false)
  const [clientId, setClientId] = useState('')
  const [secret, setSecret] = useState('')

  const showGenerateSecretModal = (id: string) => {
    setClientId(id)
    setGenerateModalVisible(true)
  }

  const cancelGenerateSecretModal = () => {
    setGenerateModalVisible(false)
  }

  const onGenerateNewSecret = () => {
    props.regenerateOauthClientSecret(clientId).then((response) => {
      setSecret(response[0].client_secret)
    })
  }

  const generateNewSecretMessage = () => {
    return (
      <>
        <strong><Translate id={'generateSecretOauthIntegration.messageType'}/>:</strong> <Translate id={'generateSecretOauthIntegration.alternateMessage'} />
      </>
    )
  }

  const closeGenerateSecretModal = () => {
    setGenerateModalVisible(false)
  }

  const getOverFlowItems = (clientId: string, accountId: string | undefined, dtaClient: boolean | undefined) => {
    if(!dtaClient){
      return [
        {
          label: translate('clientAuth.generateNewSecret'),
          key: '1',
          onClick: () => showGenerateSecretModal(clientId)
        }
      ]
    }
  }

  useEffect(() => {
    props.fetchAllOauthClients(props.accountId ? props.accountId : undefined).then((response: any) => {
      if(response) {
        setClients(response[0])
      }
    })
  }, [props, clientId])

  return (
    <>
      <CardContainer>
        {clients && clients.map(client => {
          return (
            <Card
              key={client.id}
              className={styles.oAuthCard}
              size={CardSizeTypes.LARGE}
              header={<CardHeader label={client.name} overflowMenuItems={getOverFlowItems(client.id, client.accountId, client.dtaClient)}/>}
              content={
                <CardContent>
                  <ul className={styles.oAuthCardDetails}>
                    <li>
                      <p className={styles.oAuthCardLabel}><Translate id={'oauthIntegration.integrationCardStatusLabel'} /></p>
                      <Tag type={client.status === 'ENABLED' ? TagType.ACTIVE : TagType.INACTIVE}><Translate id={`common.statuses.${client?.status.toLowerCase()}`}/></Tag>
                    </li>
                    <li>
                      <p className={styles.oAuthCardLabel}><Translate id={'oauthIntegration.integrationCardDateLabel'} /></p>
                      <p>{client.createdDate.split('T')[0]}</p>
                    </li>
                    <li>
                      <p className={styles.oAuthCardLabel}><Translate id={'oauthIntegration.integrationCardClientIdLabel'} /></p>
                      <p>{client.clientId}</p>
                    </li>
                  </ul>
                </CardContent>
              }
            />
          )
        })}
      </CardContainer>
      <CopyModal
        step={CopyModalStepType.INTRO}
        display={generateModalVisible}
        valueToBeCopied={secret}
        headline={translate('generateSecretOauthIntegration.headline')}
        buttonLabel={translate('generateSecretOauthIntegration.completeButtonLabel')}
        buttonCancelLabel={translate('deleteOauthIntegration.cancelButtonLabel')}
        onCancelCallBack={cancelGenerateSecretModal}
        buttonAlternateLabel={translate('generateSecretOauthIntegration.alternateButtonLabel')}
        toolTipMessage={translate('generateSecretOauthIntegration.clipBoardTooltipMessage') as string}
        copiedToolTipMessage={translate('generateSecretOauthIntegration.clipBoardTooltipSuccessMessage') as string}
        introSubHeading={translate('generateSecretOauthIntegration.description')}
        introMessage={translate('generateSecretOauthIntegration.message')}
        introButtonLabel={translate('generateSecretOauthIntegration.buttonLabel')}
        onIntroComplete={onGenerateNewSecret}
        message={generateNewSecretMessage()}
        onOkCallBack={closeGenerateSecretModal}
      />
    </>
  )
}
export default connect(
  null,
  { fetchAllOauthClients, enableDisableOauthClient, deleteOauthClient, regenerateOauthClientSecret }
)(OauthCard)